window.dataLayer = window.dataLayer || [];
var TestimonialExpanded = [];
var hashCode = function (str) {
  var hash = 0, len = str.length;
  if (str.length === 0) {
    return hash;
  }
  for (i = 0; i < len; i++) {
    charC = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + charC;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

$(document).ready(function () {
  var modalShown = Cookies.get('modalShown');
  var currentUrl = new URL(window.location.href);
  var utmMedium = currentUrl.searchParams.get('utm_medium');

  if (!modalShown) {
    if ($('#move_Modal')) {
      var modalHandler = setInterval(function () {
        var timeout = $('#wrap,.modal-box').attr('data-timeout');
        if (!timeout) {
          timeout = 1000;
        }
        if (utmMedium && utmMedium === 'email') {
          return false;
        }

        timeout = parseInt(timeout);
        setTimeout(function () {
          // $('body').addClass('has-modal');
          // $('#wrap,.modal-box').addClass('active');
          $('#move_Modal').modal('show');
          window.dataLayer.push({
            'event': 'modalImpression'
          });
        }, timeout);
        clearInterval(modalHandler);
      }, 100);
    }
  }

  $('#move_Modal').on('hidden.bs.modal', function () {
    Cookies.set('modalShown', true);
  });

  $('.customers-tab').each(function () {
    var $accordion_tab = $(this).find('.accordion_tab');
    var $accordion_name = $(this).find('.name');
    $accordion_tab.attr('data-name', $accordion_name.text());
  });

  $('.accordion:not(.customers-tab)').each(function () {
    var $accordion_tab = $(this).find('.accordion_tab');
    $accordion_tab.attr('data-name', $accordion_tab.text().trim());
  });


  $(document).on("click", ".accordion_tab", function () {
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");
      $(this).siblings(".content").slideUp(300);
    } else {
      if ($(this).parent().hasClass('customers-tab')) {
        if (TestimonialExpanded.indexOf($(this).attr('data-name')) == -1) {
          window.dataLayer.push({
            'event': 'TestimonialExpand'
          });
          TestimonialExpanded.push($(this).attr('data-name'));
        }
      }

      $(".accordion_tab").parent().removeClass("active");
      $(this).parent().addClass("active");
      $(".accordion .content").slideUp(300);
      $(this).siblings(".content").slideDown(300);

      window.dataLayer.push({
        'event': 'AccordionFire',
        'AccordionTitle': $(this).attr('data-name')
      });
    }
  });

  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type == 'submit') {
      if (typeof PostAffTracker === undefined || typeof PostAffTracker === 'undefined') {
        return false;
      }
      PostAffTracker.setAccountId('66b82a26');
      var sale = PostAffTracker.createAction('ppoptin1');
      var formEmail = e.detail.metaData.$email;
      var GUID = hashCode(formEmail);

      sale.setOrderID(GUID);
      sale.setData1(formEmail);
      PostAffTracker.register();
    }
  });

  $(document).on("click", ".j-scroll", function (e) {
    e.preventDefault();

    var target = $(this).attr('href');
    var targetOffset = (target === '#ordernow') ? $('section.order').offset().top : $(target).offset().top;
    $('html, body').animate({
      scrollTop: targetOffset
    }, 1000);
  });

});

$('.words span').eq(0).addClass('active');

//------------------------------------
// ANIMATE KEYWORDS
//------------------------------------

TweenMax.defaultEase = Expo.easeOut;
TweenMax.force3D = true;

// We deliver...
var weDeliver = new TimelineMax();
weDeliver.set($('.hero_word__heading'), { y: -10, x: 0, alpha: 0, scale: .75 });
weDeliver.to($('.hero_word__heading'), .25, { x: 0, alpha: 1, scale: 1 });

// Show first keyword, then callback
var word = new TimelineMax();
word.set($(".words"), { opacity: 0 });
word.to($(".words"), .05, { delay: 0.5, display: 'block', opacity: 1 });
word.to($(".words"), .5, { scale: 1, ease: Back.easeOut.config(1.7) });
word.to($(".words"), .25, { delay: .5, scale: 1, ease: Back.easeOut.config(1.7) });
word.addCallback(animateNextWord);

function setNextActiveWord() {
  var $active = $(".words .active");
  var $next = $active.next();
  if (!$next.length) {
    $next = $('.words span').eq(0);
  }
  $next.addClass('active');
  $active.removeClass('active');
}

var direction = "y";
function animateNextWord() {
  if (direction == "y") {
    word.to($(".words"), .25, { opacity: 0, y: 20, ease: Back.easeOut.config(1.7) });
    word.addCallback(setNextActiveWord);
    word.to($(".words"), 0, { y: -40 });
    word.to($(".words"), .65, { delay: 0, y: 0, opacity: 1 });
    TweenMax.delayedCall(2.5, animateNextWord);
  }

  if (direction == "x") {
    word.to($(".words"), .25, { opacity: 0, x: 40, ease: Back.easeOut.config(1.7) });
    word.addCallback(setNextActiveWord);
    word.to($(".words"), 0, { x: -20 });
    word.to($(".words"), .65, { delay: 0, x: 0, opacity: 1 });
    TweenMax.delayedCall(2.5, animateNextWord);
  }
}

function resize() {
  var docW = $(document).width();
  if (docW < 590 || direction == 'y') {
    weDeliver.to($('.we-deliver'), .5, { y: -10, x: 0, ease: Elastic.easeOut.config(.5) });
  } else {
    weDeliver.to($('.we-deliver'), .5, { y: -10, x: -180, ease: Elastic.easeOut.config(.5) });
  }
}

resize();
$(window).resize(resize);

var big_slides = $('.og-big .item').size();
var small_slides = $('.og-small .item').size();
var currentSlide = 0;

function autoChange() {
  currentSlide++;
  if (currentSlide > big_slides) { currentSlide = 1; }

  $('.og-big .item').removeClass('active');
  $('.og-big .item:nth-child(' + currentSlide + ')').addClass('active');
  $('.og-small .item').removeClass('active');
  $('.og-small .item:nth-child(' + currentSlide + ')').addClass('active');
  $('.create_list .create_item').removeClass('active');
  $('.create_list .create_item:nth-child(' + currentSlide + ')').addClass('active');
}

$('.og-small .item').click(function () {

  var currentS = $(this).index() + 1;

  console.log(currentS);
  window.dataLayer.push({
    'event': 'productImageTrigger',
    'productImageID': currentS - 1
  });
  $('.og-small .item').removeClass('active');
  $(this).addClass('active');
  $('.og-big .item').removeClass('active');
  $('.og-big .item:nth-child(' + currentS + ')').addClass('active');
  $('.og-small .item').removeClass('active');
  $('.og-small .item:nth-child(' + currentS + ')').addClass('active');
});

// form labels
$('.fly-labels .field .input').focus(function () {
  $(this).parent().addClass('focus');
});

$('.fly-labels .field .input').blur(function () {
  if (!$(this).val()) {
    $(this).parent().removeClass('focus');
  }
});



$(window).load(function () {
  //$('#wrap,.modal-box').addClass('active');
});

//  $(document).on('click', '.modal-close,.modal-closer', function(){
//     $('#wrap,.modal-box').removeClass('active');
//     $('body').removeClass('has-modal');
//  });
//  $('.modal-close,.modal-closer').click(function() {
//      $('#wrap,.modal-box').removeClass('active');
//      $('body').removeClass('has-modal');
//  });


$(document).ready(function () {
  if ($('#player0').length > 0) {
    $('#player0').get(0).play();
  }

  const pageHeader = $('header.header');
  const painSection = $('section.pain');
  var painSectionPosition;

  $(window).on('scroll', function () {
    setTimeout(function () {
      painSectionPosition = $(painSection).offset();
      if (painSectionPosition) {
        if ($(window).scrollTop() >= painSectionPosition.top) {
          $(pageHeader).addClass('scroll-up');
          $(pageHeader).css('top', painSectionPosition.top + 'px');
        } else {
          $(pageHeader).removeClass('scroll-up');
          $(pageHeader).css('top', '0px');
        }
      }
    }, 100);
  });
});



var remain_bv = 599;

function parseTime_bv(timestamp) {
  if (timestamp < 0) timestamp = 0;

  var day = Math.floor((timestamp / 60 / 60) / 24);
  var hour = Math.floor(timestamp / 60 / 60);
  var mins = Math.floor((timestamp - hour * 60 * 60) / 60);
  var secs = Math.floor(timestamp - hour * 60 * 60 - mins * 60);
  var left_hour = Math.floor((timestamp - day * 24 * 60 * 60) / 60 / 60);

  // $('span.afss_day_bv').text(day);
  // $('span.afss_hours_bv').text(left_hour);

  if (String(hour).length > 1) {
    $('span.afss_hours_by_sm').text(hour + "h");
    $('span.afss_hours_only_by_sm').text(hour + "h");
  } else {
    $('span.afss_hours_by_sm').text("0" + hour + "h :");
    $('span.afss_hours_only_by_sm').text("0" + hour + "h :");
  }
  if (String(mins).length > 1) {
    $('span.afss_mins_bv').text(mins);
    $('span.afss_mins_by_sm').text(mins + "m :");
  } else {
    $('span.afss_mins_bv').text("0" + mins + " :");
    $('span.afss_mins_by_sm').text("0" + mins + "m :");
  }
  if (String(secs).length > 1) {
    $('span.afss_secs_bv').text(secs);
    $('span.afss_secs_by_sm').text(secs + "s");
  } else {
    $('span.afss_secs_bv').text("0" + secs);
    $('span.afss_secs_by_sm').text("0" + secs + "s");
  }
}

$(document).ready(function () {
  var elems = $('.j-show-container .customers-tab').size();
  oelem = 5;

  $('.j-show-container .customers-tab:lt(' + oelem + ')').show();
  $('.j-show-all-customers').on('click', function (e) {
    e.preventDefault();
    $('.j-show-container .customers-tab:lt(' + elems + ')').show();
    $(this).hide();
  });


  var $element = $('.order-box');
  let counter = 0;
  if ($element.length > 0) {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop() + $(window).height();
      var offset = $element.offset().top

      if (scroll > offset && counter == 0) {
        setInterval(function () {
          remain_bv = remain_bv - 1;
          parseTime_bv(remain_bv);
          if (remain_bv <= 0) {
            return false;
          }
        }, 1000);
        counter = 1;
      }
    });
  }

  // Handles modal
  var isFormReady = false;
  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type === 'embedOpen' || e.detail.type === 'open') {
      isFormReady = true;
    }
    if (e.detail.type === 'submit' && e.detail.formId === 'Wzs3tb') {
      Cookies.set('modalShown', true);
      //$('#wrap,.modal-box').removeClass('active');
      // $('body').removeClass('has-modal');
      var formEmail = e.detail.metaData.$email;
      window.dataLayer.push({
        'event': 'modalSubmit',
        'formEmail': formEmail
      });
      $('#discount-form-content').hide();
      $('#signupMessage').show();
      //toastr.info($('#signupMessage').text(), '', {timeOut: 5000, "positionClass": "toast-bottom-right"});
    }
  });

  var testimonialNames = [];
  var startSlide = (window.startSlide) ? window.startSlide : 0;
  $('.j-customers').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    initialSlide: startSlide
  });

  $('.j-customers').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    getTestimonialNames();
    window.dataLayer.push({
      'event': 'testimonialScroll'
    });
  });

  function getTestimonialNames() {
    var initslide = $('.j-customers').find('.slide.slick-current');
    var initslideName = $(initslide).find('.name').text();
    if (testimonialNames.indexOf(initslideName) === -1) {
      window.dataLayer.push({
        'event': 'testimonialView',
        'testimonialViewName': initslideName
      });
      testimonialNames.push(initslideName);
    }
  }

  function getTestimonialNamesInitial() {
    var initslide = $('.j-customers').find('.slide.slick-current');
    var initslideName = $(initslide).find('.name').text();
    if (testimonialNames.indexOf(initslideName) === -1) {
      window.dataLayer.push({
        'testimonialViewNameInitial': initslideName
      });
      testimonialNames.push(initslideName);
    }
  }
  getTestimonialNamesInitial();
});

jQuery(window).on('load', function () {
  if ($('#player').length > 0) {
    const player = new Plyr('#player');
    var hasFirstPlayed = false;
    player.on('play', event => {
      if (!hasFirstPlayed) {
        window.dataLayer.push({
          'event': 'VideoEvents',
          'VideoAction': 'Play'
        });
        hasFirstPlayed = true;
      }
    });

    var durationsToWatch = [25, 50, 75];
    var durationWatched = [];
    var playerInterval = setInterval(function () {
      if (player.playing) {
        var percentageProgress = (player.currentTime / player.duration) * 100;
        var percentage = Math.floor(percentageProgress);

        if (durationsToWatch.indexOf(percentage) != -1 && durationWatched.indexOf(percentage) === -1) {
          window.dataLayer.push({
            'event': 'VideoEvents',
            'VideoAction': 'Progress',
            'VideoProgress': percentage
          });
          durationWatched.push(percentage);
        }
      }

      if (player.ended && durationWatched.indexOf(100) === -1) {
        window.dataLayer.push({
          'event': 'VideoEvents',
          'VideoAction': 'Progress',
          'VideoProgress': 100
        });
        durationWatched.push(100);
      }
    }, 100);
  }
});


//  $(document).ready(function(){
//     var variantRed = $(['power-plate-move-red']);
//     var variantSilver = $(['power-plate-move-silver']);
//     if ($('.variant-button')) {
//         $('.variant-button').on('click', function(){
//             var target = $(this).attr('powerplate-select-variant');
//             $(this).removeClass('active');

//             if (target == 'red') {
//                 $('[powerplate-select-variant="silver"]').addClass('active');
//                 $(variantRed).hide(function(){
//                     $(variantSilver).show();
//                 });
//             } else {
//                 $('[powerplate-select-variant="red"]').addClass('active');
//                 $(variantSilver).hide(function(){
//                     $(variantRed).show();
//                 });      
//             }
//         });
//     }  
//  });

(function ($) {

  $(document).ready(function () {
    let first_time_accesed = Cookies.get('_pp_first_time_accessed');
    let pp_klaviyo_origin = Cookies.get('_pp_klaviyo_origin');

    var crnturl = new URL(location.href);
    var utm_source = crnturl.searchParams.get('utm_source');
    var utm_campaign = crnturl.searchParams.get('utm_campaign');

    if (!pp_klaviyo_origin) {
      Cookies.set('_pp_klaviyo_origin', 'unknown');

      if (!first_time_accesed && (utm_source && utm_campaign)) {
        Cookies.set('_pp_klaviyo_origin', utm_source + '~' + utm_campaign);
      }
    }

    $(window).on('beforeunload', function () {
      Cookies.set('_pp_first_time_accessed', 'true');
      return undefined;
    });

    window.addEventListener("klaviyoForms", function (e) {
      window._learnq = window._learnq || [];
      let pp_klaviyo_origin = Cookies.get('_pp_klaviyo_origin');
      if (e.detail.type == 'embedOpen') {
        window._learnq.push(['identify', {
          'cp_origin': pp_klaviyo_origin
        }]);
      }

      if (e.detail.type == 'submit') {
        window._learnq.push(['identify', {
          '$email': e.detail.metaData.$email,
          'cp_origin': pp_klaviyo_origin
        }]);
      }
    });
  });

})(jQuery);